// prettier-ignore
const messages = {
  _default: `Le champ {field} n'est pas valide.`,
  after: `Le champ {field} doit être après {label}.`,
  alpha: `Le champ {field} ne peut contenir que des lettres.`,
  alpha_dash: `Le champ {field} ne peut contenir que des caractères alpha-numériques, tirets ou soulignés.`,
  alpha_num: `Le champ {field} ne peut contenir que des caractères alpha-numériques.`,
  alpha_spaces: `Le champ {field} ne peut contenir que des lettres ou des espaces.`,
  between: `Le champ {field} doit être compris entre 0:{min} et 1:{max}.`,
  confirmed: `Les {label} doivent être identiques.`,
  credit_card: `Le champ {field} est invalide.`,
  date_between: `Le champ {field} doit être situé entre 0:{min} et 0:{max}.`,
  date_format: `Le champ {field} doit être au format jj/mm/aaaa.`,
  decimal: `Le champ {field} doit être un nombre et peut contenir 0:{!nb && nb !== 0 ? "des" : nb} décimale(s).`,
  digits: `Le champ {field} doit être un nombre entier de 0:{length} chiffres.`,
  dimensions: `Le champ {field} doit avoir une taille de 0:{width} pixels par 1:{height} pixels.`,
  email: `Le champ {field} semble invalide`,
  excluded: `Le champ {field} doit être une valeur valide.`,
  ext: `Le champ {field} doit être un fichier valide.`,
  image: `Le champ {field} doit être une image.`,
  included: `Le champ {field} doit être une valeur valide.`,
  integer: `Le champ {field} doit être un entier.`,
  ip: `Le champ {field} doit être une adresse IP.`,
  length: `Le champ {field} doit contenir 0:{length} caractères.`,
  max: `Le champ {field} ne peut pas contenir plus de 0:{length} caractères.`,
  max_value: `Le champ {field} doit avoir une valeur de 0:{max} ou moins.`,
  mimes: `Le champ {field} doit avoir un type MIME valide.`,
  min: `Le champ {field} doit contenir au minimum 0:{length} caractères.`,
  min_value: `Le champ {field} doit avoir une valeur de 0:{min} ou plus.`,
  numeric: `Le champ {field} ne peut contenir que des chiffres.`,
  regex: `Le champ {field} est invalide.`,
  rangeWithMask: `Le champ {field} doit contenir entre 0:{min} et 1:{max} caractères.`,
  required: `Le champ {field} est obligatoire.`,
  size: `Le champ {field} doit avoir un poids inférieur à 0:{size}.`,
  url: `Le champ {field} n'est pas une URL valide.`,
  isAfterToday: `Le champ {field} doit être dans le futur.`,
  isSameOrAfterToday: `Le champ {field} ne peut pas être dans le passé.`,
  isSameOrBeforeToday: `Le champ {field} ne peut pas être dans le futur.`,
  isSameOrBeforeThisYear: `Le champ {field} ne peut pas être dans le futur.`,
  isXXYearsOld: `Tu dois avoir au moins 0:{currentAge} ans pour t'inscrire.`,
  isValidDate: `Le champ {field} doit être une date valide.`,
  not_start_with_spaces: `Le champ {field} ne peut pas commencer par un espace.`,
};

const locale = {
  code: "fr",
  messages,
};

export default locale;
